<app-depatureboard [config]="config"></app-depatureboard>
